import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerCardSide from '../CardDesignerCardSide';
import { getCardSideElementsConfiguration } from '../../helpers';
import { getPercentMeasurements } from '../CardDesignerCardElements/CardDesignerCardElementFrame/helpers';

const propTypes = {
  className: PropTypes.string,
  cardRef: PropTypes.object.isRequired,
  cardSide: PropTypes.shape({
    id: PropTypes.string.isRequired,
    card_template: PropTypes.shape({
      id: PropTypes.string,
      card_elements: PropTypes.array,
    }).isRequired,
  }).isRequired,
  selectedCardElementId: PropTypes.string,
  onCardElementSelect: PropTypes.func.isRequired,
  onCardElementUpdate: PropTypes.func.isRequired,
  onCardElementDelete: PropTypes.func,
  onElementConfigurationChange: PropTypes.func.isRequired,
  gridEnabled: PropTypes.bool,
};

const CardDesignerCard = ({
  className,
  cardRef,
  cardSide,
  selectedCardElementId,
  onCardElementSelect,
  onCardElementUpdate,
  onCardElementDelete,
  onElementConfigurationChange,
  gridEnabled,
}) => {
  const cardTemplate = cardSide.card_template;
  const elements = getCardSideElementsConfiguration(cardSide);
  const classes = classNames({
    'card-designer-card': true,
    'with-grid-background': gridEnabled,
    [`orientation-${cardTemplate.orientation?.toLowerCase()}`]: true,
    [className]: !!className,
  });
  const gridBoxSize = useMemo(
    () =>
      getPercentMeasurements(
        0.5,
        0.5,
        cardTemplate?.print_size ?? cardTemplate?.print_product?.print_size,
        cardTemplate.orientation,
      ),
    [cardTemplate],
  );

  return (
    <div ref={cardRef} className={classes}>
      {gridEnabled && (
        <style
          dangerouslySetInnerHTML={{
            __html: `
            .with-grid-background:after {
              background-size: ${100 * gridBoxSize.width}% ${
                100 * gridBoxSize.height
              }%;
            }
          `,
          }}
        />
      )}
      <CardDesignerCardSide
        elements={elements}
        cardRef={cardRef}
        cardTemplate={cardTemplate}
        selectedCardElementId={selectedCardElementId}
        onCardElementSelect={onCardElementSelect}
        onCardElementUpdate={onCardElementUpdate}
        onCardElementDelete={onCardElementDelete}
        onElementConfigurationChange={onElementConfigurationChange}
      />
    </div>
  );
};

CardDesignerCard.propTypes = propTypes;

export default CardDesignerCard;
